import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { Route, Switch } from "react-router";
import { ConnectedRouter } from "connected-react-router";
import { PersistGate } from "redux-persist/integration/react";
import "semantic-ui-css/semantic.min.css";

import "./index.css";
import registerServiceWorker from "./registerServiceWorker";
import { history, persistor, store } from "./store";
import Layout from "./components/Layout";
import VotifyRoutes from "./components/Votify/VotifyRoutes";
import AuthenticationCallbackHandler from "./components/Votify/RedirectHandlers/AuthenticationCallbackHandler";
import { Loader } from "semantic-ui-react";
import { commitSha } from "./config/vars";

ReactDOM.render(
  <Provider store={store}>
    <PersistGate
      persistor={persistor}
      loading={<Loader active size={"massive"} />}
    >
      {/**
       * This router stuff looks kinda messy, but it's supposed to be routing for a site with a landing
       * page that is different from the other pages. The landing page is the first route at '/' and the
       * other pages are wrapped in a Layout inside the next Switch.
       */}
      <ConnectedRouter history={history}>
        <Switch>
          <Route path="/c" component={AuthenticationCallbackHandler} />
          <Route>
            <Layout>
              <Switch>
                {/**
                 * We just let VotifyRoutes handle the rest, as so far everything in the app but the starting page
                 * is belongs there.
                 */}
                <Route component={VotifyRoutes} />
              </Switch>
            </Layout>
          </Route>
        </Switch>
      </ConnectedRouter>
    </PersistGate>
    <span style={{ display: "none" }}>{commitSha.substring(0, 8)}</span>
  </Provider>,
  document.getElementById("root"),
);
registerServiceWorker();
